<mat-form-field *ngIf="subCompanies" class="w-100">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select name="{{ name }}-inner-select"
              [ngModel]="selectedCompany?.id"
              (ngModelChange)="onInnerChange($event)"
              [disabled]="isDisabled"
              [required]="required">
    <mat-option *ngFor="let company of subCompanies" [value]="company.id">
      {{ company.name }} ({{ company.identifierName }})
    </mat-option>
  </mat-select>
</mat-form-field>